export default "__VITE_ASSET__Cs2H_PaF__"